"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("./common/constants");
var utilities_1 = require("./common/utilities");
var modelTransformer_1 = require("./modelTransformer");
var getSmartType = function (path) { return path.match(constants_1.REGEXP.smartType)[1]; };
var getSharePath = function (path) { return path.match(constants_1.REGEXP.sharePath)[1]; };
var getCollectionId = function (path) { return path.match(constants_1.REGEXP.collectionId)[1]; };
var getQueryStr = function (map) { return Array.from(map.entries()).map(function (_a) {
    var _b = __read(_a, 2), k = _b[0], v = _b[1];
    return "".concat(k, "=").concat(encodeURIComponent(v));
}).join('&'); };
var getData = function (url, params, context) { return __awaiter(void 0, void 0, void 0, function () {
    var hasFilterReqData, rawFilterReqData, _a, customFields, nonCustomFilterReqData, encodedNonCustomFilterReqData, encodedCustomFields, paramKeys, nonCustomKeys, i, key, customfilterObj, i, key, params_1, params_1_1, _b, key, value, queryUrl, fullUrl, encodedFilterReqData, result;
    var e_1, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                hasFilterReqData = context.filterReqData && JSON.stringify(context.filterReqData) !== '{}';
                rawFilterReqData = hasFilterReqData ? context.filterReqData : {};
                _a = rawFilterReqData, customFields = _a.customFields, nonCustomFilterReqData = __rest(_a, ["customFields"]);
                encodedNonCustomFilterReqData = hasFilterReqData
                    ? (0, modelTransformer_1.encodeFilterValues)(nonCustomFilterReqData)
                    : undefined;
                encodedCustomFields = hasFilterReqData && customFields
                    ? (0, modelTransformer_1.encodeFilterValues)(customFields)
                    : undefined;
                paramKeys = Object.keys(rawFilterReqData || {});
                // Override params for non-custom fields with their encoded counterparts
                if (hasFilterReqData && encodedNonCustomFilterReqData) {
                    nonCustomKeys = Object.keys(encodedNonCustomFilterReqData || {});
                    if (nonCustomKeys.length > 0) {
                        for (i = 0; i < nonCustomKeys.length; i++) {
                            key = nonCustomKeys[i];
                            params.set(key, encodedNonCustomFilterReqData[key]);
                        }
                    }
                }
                // Inject encoded custom field values into params and paramKeys
                if (hasFilterReqData && encodedCustomFields) {
                    customfilterObj = Object.keys(encodedCustomFields || {});
                    if (customfilterObj.length > 0) {
                        for (i = 0; i < customfilterObj.length; i++) {
                            key = customfilterObj[i];
                            paramKeys.push(key);
                            params.set(key, encodedCustomFields[key]);
                        }
                    }
                }
                paramKeys.push("aggsEnabled");
                paramKeys.push("sortBy");
                paramKeys.push("sortDirection");
                paramKeys.push("size");
                paramKeys.push("start");
                paramKeys.push("type");
                paramKeys.push("operator");
                paramKeys.push("time");
                paramKeys.push("keyword");
                paramKeys.push("aggrsEnabled");
                paramKeys.push("level");
                paramKeys.push("lastKey");
                paramKeys.push("scope");
                paramKeys.push("filterCantoConnector");
                paramKeys.push("arId");
                paramKeys.push("ablePartial");
                paramKeys.push("children");
                paramKeys.push("exactMatch");
                paramKeys.push("fields");
                paramKeys.push("marker");
                paramKeys.push("aiSearchEnabled");
                paramKeys.push("albumId");
                paramKeys.push("folderId");
                paramKeys.push("portalId");
                try {
                    for (params_1 = __values(params), params_1_1 = params_1.next(); !params_1_1.done; params_1_1 = params_1.next()) {
                        _b = __read(params_1_1.value, 2), key = _b[0], value = _b[1];
                        if (paramKeys.indexOf(key) === -1) {
                            params.delete(key);
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (params_1_1 && !params_1_1.done && (_c = params_1.return)) _c.call(params_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                if (params.has('customFields')) {
                    params.delete('customFields');
                }
                queryUrl = "".concat(url, "?").concat(getQueryStr(params));
                fullUrl = (0, utilities_1.resolvePrefixUrlConditionally)(queryUrl);
                encodedFilterReqData = hasFilterReqData && (encodedCustomFields || encodedNonCustomFilterReqData)
                    ? __assign(__assign(__assign({}, context.filterReqData), (encodedNonCustomFilterReqData || {})), (encodedCustomFields ? { customFields: encodedCustomFields } : {})) : context.filterReqData;
                if (!hasFilterReqData) return [3 /*break*/, 3];
                return [4 /*yield*/, fetch(fullUrl, {
                        credentials: 'include',
                        headers: getRequestHeader(context),
                        method: 'POST',
                        body: JSON.stringify(encodedFilterReqData)
                    })];
            case 1: return [4 /*yield*/, (_d.sent()).json()];
            case 2:
                result = _d.sent();
                return [3 /*break*/, 6];
            case 3: return [4 /*yield*/, fetch(fullUrl, {
                    credentials: 'include',
                    headers: getRequestHeader(context)
                })];
            case 4: return [4 /*yield*/, (_d.sent()).json()];
            case 5:
                result = _d.sent();
                _d.label = 6;
            case 6:
                result.url = queryUrl; // Dirty implementation for select all.
                return [2 /*return*/, result];
        }
    });
}); };
var getRequestHeader = function (context) {
    if (context.isPublicPortal) {
        if ((0, utilities_1.isSupportLocalStorage)() && localStorage.getItem(context.instanceId + '_Language')) {
            return { 'Accept-Language': localStorage.getItem(context.instanceId + '_Language'), 'Content-Type': 'application/json; charset=UTF-8' };
        }
        else {
            return { 'Accept-Language': context.language || 'en-US,en;q=0.9', 'Content-Type': 'application/json; charset=UTF-8' };
        }
    }
    return { 'Content-Type': 'application/json; charset=UTF-8' };
};
var getFilterParams = function (filter, params) {
    if (params === void 0) { params = new Map(); }
    params = new Map(__spreadArray(__spreadArray([], __read(Object.entries(filter || {})), false), __read(params.entries()), false));
    params.set('aggsEnabled', !!filter);
    return params;
};
var getOrderParams = function (order, params) {
    if (params === void 0) { params = new Map(); }
    params.set('sortBy', 'created');
    if (order) {
        params.set('sortBy', order.orderBy);
        params.set('sortDirection', order.ascending);
    }
    return params;
};
var getOffsetParams = function (offset, size, params) {
    if (size === void 0) { size = constants_1.DEFAULT_PAGE_SIZE; }
    if (params === void 0) { params = new Map(); }
    params.set('size', size);
    if (offset) {
        params.set('start', offset);
    }
    return params;
};
var getURLs = function (context, path) {
    var defaultUrl = '/rest/search';
    var urls = [defaultUrl];
    switch (context.category) {
        case 'library':
            //urls = ['/api/search/v1/search', '/rest/library']; break;
            urls = ['/rest/search', '/rest/library'];
            break;
        case 'folder':
            urls = ["/rest/search".concat(path), "/rest".concat(path)];
            break;
        case 'connector':
            urls = ['/rest/search', '/rest/connector/treeview'];
            break;
        case 'album':
        case 'savedfavorites':
            urls = ["/rest/search".concat(path)];
            break;
        case 'sharedFavorites':
            urls = ["/rest/search/shared".concat(path.replace('sharedFavorites', 'savedfavorites'))];
            break;
        case 'myselection':
            urls = ["/rest/search/remember/file"];
            break;
        case 'myupload':
            urls = ["/rest/search/myuploads"];
            break;
        case 'myfavorite':
            urls = ["/rest/search/myfavorites"];
            break;
        case 'brandStudio':
            urls = ["/rest/search/brandstudio"];
            break;
        case 'trashbin':
            urls = ["/rest/search/trashbin"];
            break;
        case 'share':
            urls = ["/rest/share/album/".concat(path)];
            break;
        case 'assetrequest':
            urls = ["/rest/assetrequest/collection/".concat(path)];
            break;
        default:
            break;
    }
    if (context.prefix) {
        urls = [].concat(urls).map(function (u) { return u.replace('/rest/', "/rest".concat(context.prefix).concat(context.instanceName, "/")); });
        //urls = [].concat(urls).map(u => u.replace('api/search/v1/', `api/search/v1${context.prefix}${context.instanceName}/`));
    }
    return urls; // return url OR [url1, url2];
};
var fetchAlbum = function (context, path, params) { return __awaiter(void 0, void 0, void 0, function () {
    var urls, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                urls = getURLs(context, path);
                if ((context.category === 'album' || context.category == 'recentlyadded') && !params.has('type')) {
                    params.set('type', constants_1.SMART_ALBUM_TYPES.join('|'));
                    if (path == '/allfiles' && params.get('sortBy') === 'clipcount') {
                        params.set("sortDirection", false);
                        params.set("sortBy", 'created');
                    }
                }
                if (context.category === 'smartalbum' && path !== '/allfiles') {
                    params.set('type', getSmartType(path));
                }
                if (context.albumId) {
                    params.set('albumId', context.albumId);
                }
                if (context.folderId) {
                    params.set('folderId', context.folderId);
                }
                if (context.portalId) {
                    params.set('portalId', context.portalId);
                }
                params.set('operator', 'and');
                params.set('time', Date.now());
                return [4 /*yield*/, getData(urls[0], params, context)];
            case 1:
                result = _a.sent();
                // if (urls.length > 1) {
                //     result.info = await getData(urls[1], new Map([['time', Date.now()]]));
                // }
                return [2 /*return*/, result];
        }
    });
}); };
var fetchCuratedView = function (context, path, params) { return __awaiter(void 0, void 0, void 0, function () {
    var url, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (context.category === 'album') {
                    url = "/rest".concat(path, "/customview");
                }
                else {
                    url = "/rest/share/album/".concat(getSharePath(path), "/customview");
                }
                if (!params.has('type')) {
                    params.set('type', constants_1.SMART_ALBUM_TYPES.join('|'));
                }
                params.set('size', 1000);
                params.set('operator', 'and');
                params.set('time', Date.now());
                if (context.prefix) {
                    url = url.replace('/rest/', "/rest".concat(context.prefix).concat(context.instanceName, "/"));
                }
                return [4 /*yield*/, getData(url, params, context)];
            case 1:
                result = _a.sent();
                return [2 /*return*/, result];
        }
    });
}); };
var fetchFolder = function (context, path, filter, params) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, facetUrl, contentUrl, hasFilter, folderRes, facetRes, result;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = __read(getURLs(context, path), 2), facetUrl = _a[0], contentUrl = _a[1];
                hasFilter = filter && Object.keys(filter).length > 0;
                if (!(context.category === 'folder' && !filter)) return [3 /*break*/, 2];
                params.set('type', 'folder|album');
                params.set('aggrsEnabled', false);
                params.set('level', 1);
                return [4 /*yield*/, getData(facetUrl, params, context)];
            case 1:
                folderRes = _b.sent();
                folderRes.isFolder = context.category === 'folder';
                return [2 /*return*/, folderRes];
            case 2:
                if (context.category === 'folder' && hasFilter && !params.has('type')) {
                    params.set('type', constants_1.SMART_ALBUM_TYPES.join('|'));
                }
                params.set('operator', 'and');
                params.set('time', Date.now());
                return [4 /*yield*/, getData(facetUrl, params, context)];
            case 3:
                facetRes = _b.sent();
                if (hasFilter) {
                    return [2 /*return*/, facetRes];
                }
                params.delete('operator');
                params.set('marker', undefined);
                return [4 /*yield*/, getData(contentUrl, params, context)];
            case 4:
                result = _b.sent();
                result.isFolder = context.category === 'folder';
                result.facets = facetRes.facets;
                return [2 /*return*/, result];
        }
    });
}); };
var globalSearch = function (context, path, search, params) { return __awaiter(void 0, void 0, void 0, function () {
    var sharePath, url, searchUrl, hasType, params_2, params_2_1, _a, key, value, typeParam, typeParam;
    var e_2, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                sharePath = (context === null || context === void 0 ? void 0 : context.category) === "share" ? getSharePath(path) : path;
                url = getURLs(context, sharePath);
                searchUrl = Array.isArray(url) ? url[0] : url;
                hasType = false;
                try {
                    for (params_2 = __values(params), params_2_1 = params_2.next(); !params_2_1.done; params_2_1 = params_2.next()) {
                        _a = __read(params_2_1.value, 2), key = _a[0], value = _a[1];
                        if (key === 'type') {
                            hasType = true;
                        }
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (params_2_1 && !params_2_1.done && (_b = params_2.return)) _b.call(params_2);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
                if (!search.globalSearch && !hasType) {
                    if (path == '/allfiles' || path == '/album/Unassigned') {
                        if (search.aiSearchEnabled && (search.enableCombinedSearch === true || window.location.search.indexOf('combinedSearch') > -1)) {
                            typeParam = params.get('type');
                            if (typeParam === '' || typeParam === undefined || typeParam === null) {
                                params.set('type', 'folder|album|image|video|audio|document|presentation|other');
                            }
                        }
                        else {
                            params.set('type', constants_1.SMART_ALBUM_TYPES.join('|'));
                        }
                    }
                    else {
                        if (context.category === 'smartalbum') {
                            params.set('type', getSmartType(path));
                        }
                    }
                }
                if (search.keyword)
                    params.set('keyword', search.keyword);
                if (search.aiSearchEnabled) {
                    params.set('aiSearchEnabled', search.aiSearchEnabled);
                    searchUrl = searchUrl.replace('/rest/', '/api/search/v1/');
                    if (search.enableCombinedSearch === true || window.location.search.indexOf('combinedSearch') > -1) {
                        typeParam = params.get('type');
                        if (typeParam === '' || typeParam === undefined || typeParam === null) {
                            params.set('type', 'folder|album|image|video|audio|document|presentation|other');
                        }
                    }
                }
                else if (search.enablePim === true) {
                    if (['share'].indexOf(context.category) > -1) {
                        searchUrl = searchUrl;
                    }
                    else {
                        searchUrl = searchUrl.replace('/rest/', '/api/search/v1/');
                    }
                    if ((search.fields || []).length > 0)
                        params.set('fields', (search.fields || []).join('~'));
                    if (search.exactMatch)
                        params.set('exactMatch', search.exactMatch);
                    params.set('operator', search.and ? 'and' : 'or');
                }
                else if (search.enableCombinedSearch === true || window.location.search.indexOf('combinedSearch') > -1) {
                    if (['share'].indexOf(context.category) > -1) {
                        searchUrl = searchUrl;
                    }
                    else {
                        searchUrl = searchUrl.replace('/rest/', '/api/search/v1/');
                    }
                    if ((search.fields || []).length > 0)
                        params.set('fields', (search.fields || []).join('~'));
                    if (search.exactMatch)
                        params.set('exactMatch', search.exactMatch);
                    params.set('operator', search.and ? 'and' : 'or');
                }
                else {
                    if ((search.fields || []).length > 0)
                        params.set('fields', (search.fields || []).join('~'));
                    if (search.exactMatch)
                        params.set('exactMatch', search.exactMatch);
                    params.set('operator', search.and ? 'and' : 'or');
                }
                if ((context === null || context === void 0 ? void 0 : context.category) === 'share') {
                    params.set('children', '');
                }
                params.set('time', Date.now());
                return [4 /*yield*/, getData(searchUrl, params, context)];
            case 1: return [2 /*return*/, _c.sent()];
        }
    });
}); };
var fetchSharedContent = function (context, path, params) { return __awaiter(void 0, void 0, void 0, function () {
    var sharePath, urls;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                sharePath = getSharePath(path);
                urls = getURLs(context, sharePath);
                params.set('children', '');
                params.set('time', Date.now());
                return [4 /*yield*/, getData(urls[0], params, context)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
var fetchRequestCollection = function (context, path, params) { return __awaiter(void 0, void 0, void 0, function () {
    var collectionId, url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                collectionId = getCollectionId(path);
                url = getURLs(context, collectionId);
                return [4 /*yield*/, getData(url[0], params, context)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
var fetchContents = function (_a) {
    var tenant = _a.tenant, context = _a.context, user = _a.user, path = _a.path, search = _a.search, filter = _a.filter, order = _a.order, offset = _a.offset, size = _a.size;
    return __awaiter(void 0, void 0, void 0, function () {
        var params, result, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    params = new Map();
                    result = null;
                    if (context.filterReqData && JSON.stringify(context.filterReqData) !== '{}') {
                        filter = context.filterReqData;
                    }
                    else if (filter && JSON.stringify(filter) !== '{}') {
                        context.filterReqData = filter;
                    }
                    params = getFilterParams(filter, params);
                    params = getOrderParams(order, params);
                    params = getOffsetParams(offset, size, params);
                    if (context.ablePartial) {
                        params.set('ablePartial', context.ablePartial);
                    }
                    if (context.arId) {
                        params.set('arId', context.arId);
                    }
                    if (context.isConnector) {
                        params.set('filterCantoConnector', 'false');
                        if (context.category == 'smartalbum') { // for DMC-13650
                            params.set('scope', 'cantoConnect');
                        }
                    }
                    if (context.category == 'connector') {
                        params.set('filterCantoConnector', 'false');
                        params.set('scope', 'cantoConnect');
                    }
                    if (!(search && !(Object.keys(search).length === 1 && Object.keys(search)[0] === 'enableCombinedSearch'))) return [3 /*break*/, 2];
                    return [4 /*yield*/, globalSearch(context, path, search, params)];
                case 1:
                    result = _c.sent();
                    // console.error('fetchContents: search', result);
                    return [2 /*return*/, result];
                case 2:
                    if (!(['album', 'share'].indexOf(context.category) > -1 && context.display === 'curatedView')) return [3 /*break*/, 4];
                    return [4 /*yield*/, fetchCuratedView(context, path, params)];
                case 3:
                    result = _c.sent();
                    return [2 /*return*/, result];
                case 4:
                    _b = context.category;
                    switch (_b) {
                        case 'library': return [3 /*break*/, 5];
                        case 'folder': return [3 /*break*/, 5];
                        case 'connector': return [3 /*break*/, 7];
                        case 'share': return [3 /*break*/, 9];
                        case 'assetrequest': return [3 /*break*/, 11];
                        case 'recentlyadded': return [3 /*break*/, 13];
                        case 'smartalbum': return [3 /*break*/, 13];
                        case 'album': return [3 /*break*/, 13];
                        case 'myselection': return [3 /*break*/, 13];
                        case 'myupload': return [3 /*break*/, 13];
                        case 'mycollections': return [3 /*break*/, 13];
                        case 'brandStudio': return [3 /*break*/, 13];
                        case 'myfavorite': return [3 /*break*/, 13];
                        case 'savedfavorites': return [3 /*break*/, 13];
                        case 'sharedFavorites': return [3 /*break*/, 13];
                        case 'trashbin': return [3 /*break*/, 13];
                        case 'uploadlink': return [3 /*break*/, 13];
                    }
                    return [3 /*break*/, 13];
                case 5: return [4 /*yield*/, fetchFolder(context, path, filter, params)];
                case 6:
                    result = _c.sent();
                    return [3 /*break*/, 15];
                case 7: return [4 /*yield*/, fetchFolder(context, '', filter, params)];
                case 8:
                    result = _c.sent();
                    return [3 /*break*/, 15];
                case 9: return [4 /*yield*/, fetchSharedContent(context, path, params)];
                case 10:
                    result = _c.sent();
                    return [3 /*break*/, 15];
                case 11:
                    if (context.lastKey) {
                        params.set('lastKey', context.lastKey);
                    }
                    return [4 /*yield*/, fetchRequestCollection(context, path, params)];
                case 12:
                    result = _c.sent();
                    return [3 /*break*/, 15];
                case 13: return [4 /*yield*/, fetchAlbum(context, path, params)];
                case 14:
                    result = _c.sent();
                    return [3 /*break*/, 15];
                case 15: 
                // console.error('fetchContents: default', result);
                return [2 /*return*/, result];
            }
        });
    });
};
exports.default = fetchContents;
